'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { InputAdornment } from '../Input';
import { SearchIcon as DefaultSearchIcon } from './SearchIcon';
import ClearIcon from '@mui/icons-material/Clear';
import { styled } from '@mui/material/styles';
import { composeEventHandlers } from '../utils/composeEventHandlers';
import { useControlled } from '@mui/material';
const StyledIconButton = styled(IconButton)(({ edge }) => ({
    height: '1.5rem',
    width: '1.5rem',
    ...edge === 'end' && {
        '&.MuiIconButton-edgeEnd': {
            marginRight: 0
        }
    }
}));
export const Search = forwardRef(({ SearchIcon = DefaultSearchIcon, placeholder, value: valueProp, onChange, onClear, variant = 'outlined', defaultValue = '', onEnter, onKeyDown, ...props }, ref) => {
    const [value, setValue] = useControlled({
        controlled: valueProp,
        default: defaultValue,
        name: 'Search'
    });
    const updateValue = (e) => {
        setValue(e.target.value);
    };
    const clearValue = () => {
        setValue('');
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onEnter?.(e);
        }
        onKeyDown?.(e);
    };
    const handleChange = composeEventHandlers(updateValue, onChange);
    const handleClear = composeEventHandlers(clearValue, onClear);
    return (_jsx(TextField, { ...props, InputProps: {
            'data-fuel-size': props.size,
            ...props.InputProps,
            endAdornment: (_jsx(InputAdornment, { position: 'end', children: Boolean(value) && (_jsx(StyledIconButton, { "aria-label": 'Clear', className: 'FuelSearchInputClearButton', edge: 'end', onClick: handleClear, size: 'small', type: 'reset', children: _jsx(ClearIcon, {}) })) })),
            startAdornment: (_jsx(InputAdornment, { position: 'start', children: _jsx(SearchIcon, {}) }))
        }, onChange: handleChange, onKeyDown: handleKeyDown, placeholder: placeholder || 'Search', ref: ref, value: value, variant: variant }));
});
Search.displayName = 'Search';
